import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { combineLatest, map, Observable } from 'rxjs';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { BoundType, LocationInfoMap, Duration } from '@fcom/dapi';
import { FinnairBoundItem } from '@fcom/dapi/api/models/finnair-bound-item';
import { FinnairDisruptedBoundItem } from '@fcom/dapi/api/models/finnair-disrupted-bound-item';
import { NotificationLayout, NotificationTheme } from '@fcom/ui-components';
import { getCityName } from '@fcom/common/utils/booking.utils';
import { finShare } from '@fcom/rx';

import { BUS_AIRCRAFT_CODE } from '../../../interfaces/utils.interface';
import { EndPointChanges } from '../../../interfaces/endpoint-changes.interface';

@Component({
  selector: 'fin-itinerary-timeline-bound-header',
  styleUrls: ['../arrow-block.scss'],
  templateUrl: './itinerary-timeline-bound-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ItineraryTimelineBoundHeaderComponent implements OnInit {
  public readonly BoundType = BoundType;
  public readonly BUS_AIRCRAFT_CODE = BUS_AIRCRAFT_CODE;

  public readonly NotificationLayout = NotificationLayout;
  public readonly NotificationTheme = NotificationTheme;
  public readonly SvgLibraryIcon = SvgLibraryIcon;

  @Input()
  boundType: BoundType;

  @Input()
  bound$: Observable<FinnairBoundItem | FinnairDisruptedBoundItem>;

  @Input()
  locations$: Observable<LocationInfoMap>;

  @Input()
  departureChanges: EndPointChanges;

  @Input()
  arrivalChanges: EndPointChanges;

  @Input()
  boundChangeDuration: Duration;

  @Input()
  showNoChangesNotification: boolean;

  @Input()
  title: string;

  departureCity$: Observable<string>;
  arrivalCity$: Observable<string>;

  ngOnInit(): void {
    const latestBoundAndLocations$ = combineLatest([this.bound$, this.locations$]);

    this.departureCity$ = latestBoundAndLocations$.pipe(
      map(([bound, locations]) => getCityName(bound.departure.locationCode, locations)),
      finShare()
    );

    this.arrivalCity$ = latestBoundAndLocations$.pipe(
      map(([bound, locations]) => getCityName(bound.arrival.locationCode, locations)),
      finShare()
    );
  }
}
